import { render, staticRenderFns } from "./AccessItem.vue?vue&type=template&id=658ec0c8&scoped=true&"
import script from "./AccessItem.ts?vue&type=script&lang=ts&"
export * from "./AccessItem.ts?vue&type=script&lang=ts&"
import style0 from "./AccessItem.scss?vue&type=style&index=0&id=658ec0c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658ec0c8",
  null
  
)

export default component.exports